import React, { useState } from "react";
import { Link } from 'react-router-dom'
import Button from '../../../components/Button/Button'
import InputField from '../../../components/InputField/InputField'
import { TagsInput } from 'react-tag-input-component'
import Skeleton from "react-loading-skeleton";

const Profiledetails = ({ isActiveTab, data, isFetching }) => {
    return (

        <>
            <div className={`ContainerTabForAllTabData tabWrapper ${isActiveTab && 'active'}`}>
                <div className="Headingforallheader slotdetailsfixpd">
                    <div className="slottabbtn flex-between w-100">
                        <h2 className="heading-2">Profile Details</h2>

                        {/* <Button name={'Edit Profile'} className="BlueFillButton" /> */}
                    </div>
                </div>

                <div className="border-btm w-100"></div>

            <div className="bodyDataForallUserdata Adfixwidthalldata">
                <div className="profileDetailsWrap">
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : "First Name"}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : data?.firstName ? data?.firstName : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : "Last Name"}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : data?.lastName ? data?.lastName : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : "Designation"}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"120px"} /> : data?.profession?.designation ? data?.profession?.designation : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"140px"} /> : "Current Company"}
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {isFetching ? <Skeleton width={"130px"} /> : data?.profession?.company ? data?.profession?.company : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"130px"} /> : "Phone Number"}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : data?.mobileNumber ? data?.mobileNumber : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"80px"} /> : "Email"}
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {isFetching ? <Skeleton width={"170px"} /> : data?.email ? data?.email : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"90px"} /> : "Linkedin"}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"200px"} /> : data?.linkedin ? <a className='SocialLink' target='_blank' href={data?.linkedin.slice(0,4) === "http" ? data?.linkedin : "https://" + data?.linkedin} rel="noreferrer">
                            {data?.linkedin}
                            </a>
                            :
                            <span>{"---"}</span>}
                        </div>
                    </div>

                        <div className="dashedDivider"></div>

                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : "About"}
                        </div>
                        <div className="profileData AdAnssetwidth">
                           {isFetching ? <Skeleton width={"300px"} /> : data?.about ? data?.about : "---"}
                        </div>
                    </div>

                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"200px"} /> : "Years of Experience"}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {isFetching ? <Skeleton width={"100px"} /> : data?.profession?.yrsOfExp ? data?.profession?.yrsOfExp : "---"}{data?.profession?.yrsOfExp > 1 ? '+' : ''}{data?.profession?.yrsOfExp ? "year" : ""}{+data?.profession?.yrsOfExp > 1 ? 's' : ''}
                        </div>
                    </div>

                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"170px"} /> : "Functional focus area"}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            <div className="dataexpertise">
                                {isFetching ? <Skeleton width={"400px"} /> : data?.interests?.length > 0 ? data?.interests?.map((item, index) => (
                                    <div className='text2' key={index}>{item?.interest}</div>
                                )) : "---"}
                            </div>
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {isFetching ? <Skeleton width={"160px"} /> : "Mentoring On"}
                        </div>
                        <div className="profileData AdAnssetwidth">
                        <div className="dataexpertise">
                        {isFetching ? <Skeleton width={"400px"} /> : data?.topics?.length > 0 ? data?.topics?.map((item, index) => (
                                    <div className='text2' key={index}>{item?.Topic}</div>
                                )) : "---"}
                            </div>
                        </div>
                    </div>
                </div>

                </div>

            </div>

            {/* EDIT PROFILE */}
            {/* <div className={`ContainerTabForAllTabData tabWrapper ${isActiveTab && 'active'}`}>
                <div className="Headingforallheader">
                    <div className="flex-between w-100">
                        <h2 className="heading-2">Edit</h2>
                    </div>
                </div>

                <div className="border-btm w-100"></div>

                <div className="bodyDataForallUserdata">
                    <div className="AdMainsetting mt-20  overflow">

                        <div className="userProfileEdit mulipleFormInputWrap">
                            <h4 className='lableHeading'>Avatar</h4>
                            <div className="leftWrapperPrfile mb25">
                                <div className="userProfileEditTab">
                                    <label className="userProfile pointer" for="bgimg">
                                        <img
                                            src="/assets/img/user1.png" alt="" className="userimg" />
                                        <input type="file" name="bgimg" id="bgimg" />
                                        <img src="/assets/img/edit.png" alt="" className="editimg pointer"
                                        />
                                    </label>
                                </div>
                                <p className='mt-10 text2'>File types allowed are: jpg, jpeg, png</p>
                            </div>
                        </div>
                        <div className="mulipleFormInputWrap flexbox">
                            <h4 className='lableHeading'>Full Name <span className={"impRed"}> *</span></h4>
                            <div className="multipleFormInput flex-center">
                                <InputField
                                    name={"firstName"}

                                    placeholder={"First Name"}
                                />
                                <InputField
                                    name={"lastName"}

                                    placeholder={"Last Name"}
                                />
                            </div>
                        </div>

                        <div className="mulipleFormInputWrap flexbox">
                            <h4 className='lableHeading'>Designation <span className={"impRed"}> *</span>
                            </h4>
                            <div className="multipleFormInput flex-center">
                                <InputField
                                    name={"designation"}
                                    type={'text'}
                                    placeholder={"Input designation"}
                                />
                            </div>
                        </div>

                        <div className="mulipleFormInputWrap flexbox">
                            <h4 className='lableHeading'>Current Company Name <span className={"impRed"}> *</span></h4>
                            <div className="multipleFormInput flex-center">
                                <InputField
                                    type={"text"}
                                    name={"mobileNumber"}
                                    placeholder={"Input company name"}
                                />
                            </div>
                        </div>

                        <div className="mulipleFormInputWrap flexbox">
                            <h4 className='lableHeading'>Hourly Rate  <span className={"impRed"}> *</span> </h4>
                            <div className="multipleFormInput flex-center">
                                <InputField
                                    type={"text"}
                                    name={"email"}
                                    placeholder={"Input cost per hour for a sesssion"}
                                />
                            </div>
                        </div>


                        <div className="mulipleFormInputWrap flexbox">
                            <h4 className='lableHeading'>Email <span className={"impRed"}> *</span></h4>
                            <div className="multipleFormInput flex-center">
                                <InputField
                                    name={"email"}
                                    type={'email'}
                                    placeholder={"Input email"}
                                />
                            </div>
                        </div>
                        <div className="mulipleFormInputWrap flexbox">
                            <h4 className='lableHeading'>Phone Number</h4>
                            <div className="multipleFormInput flex-center">
                                <InputField
                                    name={"phone"}
                                    type={'tel'}
                                    placeholder={"Input phone number"}
                                />
                            </div>
                        </div>
                        <div className="mulipleFormInputWrap flexbox">
                            <h4 className='lableHeading'>Linkedin Profile <span className={"impRed"}> *</span></h4>
                            <div className="multipleFormInput flex-center">
                                <InputField
                                    name={"link"}
                                    type={'url'}
                                    placeholder={"Input profile link"}
                                />
                            </div>
                        </div>


                        <div className="mulipleFormInputWrap flexbox">
                            <h4 className='lableHeading'>Functional focus area <span className={"impRed"}> *</span></h4>
                            <div className="multipleFormInput flex-center TagsInputbar">
                                <TagsInput
                                    value={selected}
                                    onChange={setSelected}
                                    name="fruits"
                                    placeHolder="Input expertise"
                                />
                            </div>
                        </div>

                        <div className="mulipleFormInputWrap flexbox">
                            <h4 className='lableHeading'>Expertise  <span className={"impRed"}> *</span></h4>
                            <div className="multipleFormInput flex-center TagsInputbar">
                                <TagsInput
                                    value={selected}
                                    onChange={setSelected}
                                    name="fruits"
                                    placeHolder=""
                                />
                            </div>
                        </div>


                        <div className="mulipleFormInputWrap flexbox">
                            <h4 className='lableHeading'>Years of Experience </h4>
                            <div className="multipleFormInput flex-center">
                                <InputField
                                    type={'text'}
                                    placeholder={"Input experience"}
                                />
                            </div>
                        </div>
                        <div className="mulipleFormInputWrap flexbox">
                            <h4 className='lableHeading'>About Mentor</h4>
                            <div className="multipleFormInput flex-center textareainput">
                                <textarea placeholder='Input some details about Mentor to describe'></textarea>
                            </div>
                        </div>

                        <div className="mulipleFormInputWrap flexbox">
                            <h4 className='lableHeading'>Fluent In</h4>
                            <div className="multipleFormInput flex-center TagsInputbar">
                                <TagsInput
                                    value={selected}
                                    onChange={setSelected}
                                    name="fruits"
                                    placeHolder="Input Languages"
                                />
                            </div>
                        </div>

                        <div className="border-btm w-100"></div>
                        <div className="FooterAddmentors flex flexend">
                            <Button name={'Discard'} className={'buttontext GreyFillButton'} />
                            <Button name={'Save Changes'} className="active buttontext BlueFillButton" />
                        </div>
                    </div>
                </div>
            </div> */}
        </>

    )
}

export default Profiledetails
